module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_225_DOWN_LEFT.23f1777c.png";